import { constants } from "./constants";
import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("snackbar");

export const showSuccessSnackbar = actionCreator<string>(
  constants.SnackbarSuccess
);

export const showErrorSnackbar = actionCreator<string>(constants.SnackbarError);

export const showWarningSnackbar = actionCreator<string>(
  constants.SnackbarWarning
);

export const showInfoSnackbar = actionCreator<string>(constants.SnackbarInfo);
export const clearSnackbar = actionCreator<void>(constants.SnackbarClear);
